<confirmaciongenerica #appconfirmacion (ConfirmoUsuario)="ConfirmoUsuario($event)" [TextoSiMostrar]="'Aceptar'" [TextoNoMostrar]="'Cancelar'"></confirmaciongenerica>
<mat-progress-bar color="primary" mode="indeterminate" *ngIf="mostrarCargando"></mat-progress-bar>
<adicionar-items-lista #appvaloresposiblesmodal (ConfirmoUsuario)="SeleccionoValoresPosibles($event)"></adicionar-items-lista>

<div class="row mt-5">
    <div class="d-flex justify-content-between">
        <div>
            <h2 class="titleppal">{{tituloForma}}</h2>
            <div class="line">
                <div class="line2"></div>
            </div>
        </div>
        <div class="botoncerrar">
            <a type="button" (click)="CancelarRegistro()">
                <mat-icon aria-hidden="false">close</mat-icon>
            </a>
        </div>
    </div>
    <div class="position-relative">
        <a type="button" (click)="NuevoParametro()" *ngIf="idTabSeleccionado === 1 && !editarRegistroParametro" class="accesoAdd">
            <mat-icon>add</mat-icon>
        </a>
        <div class="col-md-12 col-lg-2 col-12 btnesmaestro" *ngIf="idTabSeleccionado === 1 && editarRegistroParametro">
            <a type="button" class="icnTable" (click)="GuardarParametro()">
                <mat-icon>save</mat-icon>
            </a>
            <a type="button" class="icnTable" (click)="CancelarEditarParametro()">
                <mat-icon>close</mat-icon>
            </a>
        </div>
    </div>
    <mat-tab-group class="tabcontroldatos" mat-align-tabs="start" #tabGroup (selectedTabChange)="tabSeleccionado($event)">
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Datos</span>
            </ng-template>
            <div [formGroup]="form" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off">
                <div class="col-md-6 col-lg-2 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Nombre del reporte (*)</mat-label>
                        <input matInput formControlName="nombreConsulta" autocomplete="off">
                        <mat-error *ngIf="form.get('nombreConsulta').hasError('required')">El Reporte es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('nombreConsulta').hasError('maxlength')">La longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Descripción (*)</mat-label>
                        <input matInput formControlName="descripcionConsulta" autocomplete="off">
                        <mat-error *ngIf="form.get('descripcionConsulta').hasError('required')">La Descripción es un campo requerido</mat-error>
                        <mat-error *ngIf="form.get('descripcionConsulta').hasError('maxlength')">la longitud máxima es 500</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Tipo de reporte (*)</mat-label>
                        <mat-select formControlName="idTipoConsulta">
                            <mat-option [value]="item.id" *ngFor="let item of this.listaTipos">{{item.tipoConsulta}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('idTipoConsulta').hasError('required')">El Tipo de reporte es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Aplicaciones (*)</mat-label>
                        <mat-select formControlName="aplicacionesSeleccionada" multiple>
                            <mat-option [value]="item.idAplicacion" *ngFor="let item of this.listaDatosAplicaciones">{{item.nombreAliado}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('aplicacionesSeleccionada').value.length === 0">Es necesario seleccionar al menos una aplicación</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Roles (*)</mat-label>
                        <mat-select formControlName="rolesSeleccionados" multiple>
                            <mat-option [value]="item.idRol" *ngFor="let item of this.listaDatosRoles">{{item.nombreRol}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Usuarios (*)</mat-label>
                        <mat-select formControlName="usuariosSeleccionados" multiple>
                            <mat-option [value]="item.idUsuario" *ngFor="let item of this.listaDatosUsuarios">{{item.login}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="form.get('id').value > 0">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Estado (*)</mat-label>
                        <mat-select formControlName="activo">
                            <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaEstado">{{item.descripcion}}</mat-option>
                        </mat-select>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Columna totalizar</mat-label>
                        <input matInput formControlName="columnaTotalizar" autocomplete="off">
                        <mat-error *ngIf="form.get('columnaTotalizar').hasError('maxlength')">la longitud máxima es 100</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Tipo exportación (*)</mat-label>
                        <mat-select formControlName="tipoExportacion">
                            <mat-option [value]="item.descripcion" *ngFor="let item of this.listaTipoExportacion">{{item.descripcion}}</mat-option>
                        </mat-select>
                        <mat-error *ngIf="form.get('tipoExportacion').hasError('required')">El Tipo exportación es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="this.form.get('tipoExportacion').value === 'PLANO'">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Extensión exportación (*)</mat-label>
                        <input matInput formControlName="extensionArchivoPlano" autocomplete="off">
                        <mat-error *ngIf="form.get('extensionArchivoPlano').hasError('required')">La Extensión del archivo es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-3 col-12" *ngIf="this.form.get('tipoExportacion').value === 'PLANO'">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Separador archivo plano exportación</mat-label>
                        <input matInput formControlName="separadorArchivoPlano" autocomplete="off">
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-12 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Consulta (*)</mat-label>
                        <textarea matInput formControlName="queryEjecutar" autocomplete="off" rows="10"></textarea>
                        <mat-error *ngIf="form.get('queryEjecutar').hasError('required')">La consulta es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
                <div class="col-md-6 col-lg-12 col-12">
                    <mat-form-field appearance="fill" class="d-block">
                        <mat-label>Consulta exportación (*)</mat-label>
                        <textarea matInput formControlName="queryExportar" autocomplete="off" rows="10"></textarea>
                        <mat-error *ngIf="form.get('queryExportar').hasError('required')">La consulta exportación es un campo requerido</mat-error>
                    </mat-form-field>
                </div>
            </div>
        </mat-tab>
        <mat-tab>
            <ng-template mat-tab-label>
                <span>Parámetros</span>
            </ng-template>
            <div class="d-flex flex-column">
                <div [formGroup]="formParametros" class="row pr-0 pl-0 mt-4 m-0" autocomplete="off" *ngIf="editarRegistroParametro">
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Parámetro (*)</mat-label>
                            <input matInput formControlName="nombreParametro" autocomplete="off">
                            <mat-error *ngIf="formParametros.get('nombreParametro').hasError('required')">El Parámetro es un campo requerido</mat-error>
                            <mat-error *ngIf="formParametros.get('nombreParametro').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Nombre del parametro (*)</mat-label>
                            <input matInput formControlName="descripcionParametro" autocomplete="off">
                            <mat-error *ngIf="formParametros.get('descripcionParametro').hasError('required')">La Descripción es un campo requerido</mat-error>
                            <mat-error *ngIf="formParametros.get('descripcionParametro').hasError('maxlength')">La longitud máxima es 100</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Orden (*)</mat-label>
                            <input matInput formControlName="orden" autocomplete="off">
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Filtro (*)</mat-label>
                            <mat-select formControlName="filtroPrincipal">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaRequerido">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Requerido (*)</mat-label>
                            <mat-select formControlName="requerido">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaRequerido">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Tipo de parámetro (*)</mat-label>
                            <mat-select formControlName="idTipoParametro">
                                <mat-option [value]="item.id" *ngFor="let item of this.listaTiposParametros">{{item.tipoParametro}}</mat-option>
                            </mat-select>
                            <mat-error *ngIf="formParametros.get('idTipoParametro').hasError('required')">la tipo parámetro es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="formParametros.get('idTipoParametro').value === this.idTipoParametroSeleccion">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Valores posibles (*)</mat-label>
                            <input matInput formControlName="valoresPosibles" autocomplete="off" [readonly]="true">
                            <mat-error *ngIf="formParametros.get('valoresPosibles').hasError('required')">la lista de valores posibles es un campo requerido</mat-error>
                            <button matSuffix mat-icon-button (click)="EditarParametroValoresPosibles()">
                                <mat-icon>edit</mat-icon>
                            </button>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12" *ngIf="formParametros.get('idTipoParametro').value === this.idTipoParametroConsulta">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Valores posibles (*)</mat-label>
                            <input matInput formControlName="valoresPosibles" autocomplete="off">
                            <mat-error *ngIf="formParametros.get('valoresPosibles').hasError('required')">la lista de valores posibles es un campo requerido</mat-error>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-2 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Mostrar parámetro usuario (*)</mat-label>
                            <mat-select formControlName="mostrarParametro">
                                <mat-option [value]="item.seleccionado" *ngFor="let item of this.listaRequerido">{{item.descripcion}}</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                    <div class="col-md-6 col-lg-3 col-12">
                        <mat-form-field appearance="fill" class="d-block">
                            <mat-label>Valor defecto (*)</mat-label>
                            <input matInput formControlName="valorDefecto" autocomplete="off">
                        </mat-form-field>
                    </div>

                </div>
                <div class="mat-elevation-z8 p-0">
                    <div class="table-responsive">
                        <table mat-table [dataSource]="dataSourceParametros" matSort class="table table-striped table-hover">

                            <!-- id Column -->
                            <ng-container matColumnDef="id">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> ID</th>
                                <td mat-cell *matCellDef="let row"> {{row.id}} </td>
                            </ng-container>
                            <!-- nombreParametro Column -->
                            <ng-container matColumnDef="nombreParametro">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Parámetro </th>
                                <td mat-cell *matCellDef="let row"> {{row.nombreParametro}} </td>
                            </ng-container>
                            <!-- descripcionParametro Column -->
                            <ng-container matColumnDef="descripcionParametro">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Nombre parámetro </th>
                                <td mat-cell *matCellDef="let row"> {{row.descripcionParametro}} </td>
                            </ng-container>
                            <!-- tipoParametro Column -->
                            <ng-container matColumnDef="tipoParametro">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Tipo parámetro </th>
                                <td mat-cell *matCellDef="let row"> {{row.tipoParametro}} </td>
                            </ng-container>
                            <!-- orden Column -->
                            <ng-container matColumnDef="orden">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Orden </th>
                                <td mat-cell *matCellDef="let row"> {{row.orden}} </td>
                            </ng-container>
                            <!-- acciones Column -->
                            <ng-container matColumnDef="acciones">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header>
                                    Acciones
                                </th>
                                <td mat-cell *matCellDef="let row, let i">
                                    <a type="button" class="icnTable" (click)="EditarParametro(row)" *ngIf="!editarRegistroParametro">
                                        <mat-icon>edit</mat-icon>
                                    </a>
                                    <a type="button" class="icnTable" (click)="EliminarParametro(row)" *ngIf="!editarRegistroParametro">
                                        <mat-icon>delete</mat-icon>
                                    </a>
                                </td>
                            </ng-container>

                            <tr mat-header-row *matHeaderRowDef="columnasEncabezadoParametro"></tr>
                            <tr mat-row *matRowDef="let row; columns: columnasEncabezadoParametro;"></tr>

                            <!-- Row shown when there is no matching data. -->
                            <tr class="mat-row" *matNoDataRow>
                                <td class="mat-cell" colspan="9">No existen datos con el filtro indicado </td>
                            </tr>
                        </table>
                    </div>
                </div>
                <div class="fondopaginador">
                    <mat-paginator [pageSize]="10" [pageSizeOptions]="[10, 20, 30, 40, 50]" aria-label="Select page of users"></mat-paginator>
                </div>
            </div>
        </mat-tab>
    </mat-tab-group>
    <div class="d-flex flex-row-reverse pr-0" *ngIf="idTabSeleccionado === 0 || (idTabSeleccionado === 1 && !editarRegistroParametro)">
        <div *ngIf="this.tamanoAppService.mostrarModoEscritorio">
            <button mat-button class="botonguardardatos" (click)="Guardar()" [disabled]="mostrarCargando">
                <div class="d-flex flex-row-reverse">
                    <mat-icon class="botonguardardatosicono">check_circle_outline</mat-icon>
                    <span class="botonguardardatostexto">{{tituloBoton}}</span>
                </div>
            </button>
        </div>
    </div>
</div>